export default {"src":"https://images-cdn-staging.curipod.com/d-616370d5/_next/static/media/common_sense_media.9c180185.svg","height":123,"width":300};